/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import useTranslate from 'hooks/useTranslate';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';
import SimpleMessagePage from 'components/SimpleMessagePage';
import ActionButtonContainer from 'components/ActionButtonsContainer';
import Button from 'components/Button';
import CancelButton from 'features/CancelButton';

interface PropTypes {
  restartPath: string;
}

const ErrorView: React.FC<PropTypes> = ({ restartPath }) => {
  const t = useTranslate();
  const tMd = useMarkdownTranslate();
  return (
    <SimpleMessagePage
      headerTitle={'prequal.error.title'}
      message={tMd('prequal.error.message')}
    >
      <ActionButtonContainer>
        <Button
          id="continueToApplication"
          variant="contained"
          href={restartPath}
        >
          {t('prequal.error.continueButton')}
        </Button>
        <CancelButton />
      </ActionButtonContainer>
    </SimpleMessagePage>
  );
};

export default ErrorView;
